import React, { Component } from 'react';
import { Cookies } from "react-cookie";
import { Loading } from "./Loading"

import { VotePageDecorativeElements } from "../../until925/components/VotePageDecorativeElements";
import { ShowNotStarted, SetName, NoVote } from "../../until925/components/NoVotingPage";
import { VotingPage, VotingSilencePage, VotingNumberPage } from "../../until925/components/VotingPage";
import '../../until925/styles/Vote.css';

const userCookies = new Cookies();

export class VoteWrapper extends Component {
    static displayName = "Vote";

    constructor(props) {
        super(props);

        this.state = {
            currentActiveShow: false,
            currentActivePoll: false,
            mostRecentPollID: 0,
            loading: true,
            userCookieData: userCookies.get('userData') || "NOT SET",
            userName: "",
            userID: "",
        };

        this.setIntialUserId = this.setIntialUserId.bind(this)

        this.handleAddUserName = this.handleAddUserName.bind(this)
    }

    componentDidMount() {
        this.getPoll()
        this.timerId = setInterval(() => this.getPoll(), 2000); //2 Seconds
    }

    componentWillUnmount() {
        clearInterval(this.timerId)
    }

    async getPoll() {
        const response = await fetch('api/getPollInfo');
        const data = await response.json();
        this.setState({
            currentActiveShow: data["value"]["openShow"],
            currentActivePoll: data["value"]["openVote"],
            mostRecentPollID: data["value"]["recentPollId"],
            mostRecentVoteType: data["value"]["voteType"],
            loading: false
        });

        if (data["value"]["openShow"]) {
            this.setIntialUserId();
        } else {
            this.resetUserId();
        }
        
    }

    setIntialUserId() {
        let userCookieData = (this.state.userCookieData);
        if (userCookieData === "NOT SET") {
            let userID = this.makeId(7);
            this.setState({
                userCookieData: userID,
                userName: "",
                userID: userID
            })
            userCookies.set('userData', userID);
        } else if (userCookieData.length < 8) {
            this.setState({ userID: (this.state.userCookieData) })
        } else {
            const splitParty = (this.state.userCookieData).split("|")
            this.setState({
                userID: splitParty[0],
                userName: splitParty[1]
            })
        }
    }

    makeId(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    resetUserId() {
        this.setState({
            userCookieData: "NOT SET",
            userName: "",
            userID: "",
        })
        userCookies.remove('userData');
    }

    handleAddUserName(nameToAdd) {
        if (this.state.currentActiveShow && nameToAdd !== "") {
            let newData = (this.state.userID) + "|" + nameToAdd
            this.setState({
                userCookieData: newData,
                userName: nameToAdd
            })
            userCookies.set('userData', newData);
        }
    }

    render() {
        const loading = (this.state.loading);
        const activeShow = (this.state.currentActiveShow);

        let innerComponent;
        if (loading) { innerComponent = <Loading /> }
        else if (!activeShow) { innerComponent = <ShowNotStarted /> }
        else {
            const nameNotSet = (this.state.userName === "")
            const activePoll = (this.state.currentActivePoll);
            const recentVoteType = (this.state.mostRecentVoteType);
            const pollData = {
                "userID": (this.state.userID),
                "userName": (this.state.userName),
                "activePollId": (this.state.mostRecentPollID)
            }
            if (nameNotSet) { innerComponent = <SetName handler={this.handleAddUserName} /> }
            else if (!activePoll) { innerComponent = <NoVote userName={this.state.userName} /> }
            else if (recentVoteType === 3) { innerComponent = <VotingSilencePage pollData={pollData} /> }
            else if (recentVoteType === 20) { innerComponent = <VotingNumberPage pollData={pollData} poleType={"Phone"} /> }
            else if (recentVoteType === 21) { innerComponent = <VotingNumberPage pollData={pollData} poleType={"Computer"} /> }
            else if (recentVoteType === 22) { innerComponent = <VotingNumberPage pollData={pollData} poleType={"Door"} /> }
            else { innerComponent = <VotingPage pollData={pollData} /> }
        }
        
        return (
            <div className="votePage page notShow">
                <VotePageDecorativeElements />
                {innerComponent}
            </div>
        );
    }
}